import { render, staticRenderFns } from "./subcon-submit-success.vue?vue&type=template&id=cdae4552&"
import script from "./subcon-submit-success.vue?vue&type=script&lang=js&"
export * from "./subcon-submit-success.vue?vue&type=script&lang=js&"
import style0 from "./subcon-submit-success.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports